<div #target>
  <tmo-spinner
    [setDelay]="
      contentData && customerAccountBillingDetails && lineDetails && isChangedMsisdnloaded
    "
  ></tmo-spinner>
  <section scId="SC1111" class="contentDisplay">
    <tmo-page-titles
      id="page-title"
      [pageTitle]="contentData?.lineDetails"
      [grayBackground]="false"
      [accountPage]="true"
      [accountId]="customerAccountBillingDetails?.accountNumber"
      [accountText]="contentData?.account"
      [numAlerts]="totalNotifications"
      [alertSuffix]="contentData?.alerts"
      (toggleAlertEmitter)="toggleAlertChange($event)"
    >
    </tmo-page-titles>
    <ng-container *ngIf="contentData">
      <tmo-alerts-section
        id="alert-section-12"
        (totalAccountNotifications)="updateNotifications($event)"
        [contentData]="contentData"
        [toggleAlerts]="!toggleAlerts"
        [showIndicators]="true"
      >
      </tmo-alerts-section>
    </ng-container>
    <tmo-popup
      id="popup-toast"
      *ngIf="contentData && restoreServiceResponse?.orderId && restoreServiceResponse?.isBlocked"
      [message]="orderIdText"
    ></tmo-popup>
    <div class="row" *ngIf="errorMessage">
      <div class="col-12 m-t-lg" *ngFor="let error of errorMessage">
        <ng-container *ngIf="error.userMessage">
          <tmo-error-message-detail
            id="error-message-detail"
            [errorMessage]="error"
          ></tmo-error-message-detail>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="contentData && customerAccountBillingDetails">
      <div class="row">
        <div class="col-12 m-t-lg m-b-lg" *ngIf="isTouristPlan">
          <p class="alert-text">
            <i class="fa fa-flag def alert-icon"></i>{{ contentData?.touristPlanChangeMessage }}
          </p>
        </div>
      </div>
      <div class="row">
        <!-- Start left panel Section-->
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 m-t-xl" *ngIf="!isSingleLine && contentData?.seeOtherLines">
              <p class="lead bold">{{ contentData?.seeOtherLines }}</p>
            </div>
            <div *ngIf="!isSingleLine" class="col-12 m-t-lg">
              <tmo-multiline-msisdn-dropdown
                id="msisdn-line"
                [isLineDetailsPage]="true"
                (isMsisdnUpdated)="onMsisdnChange($event)"
              >
              </tmo-multiline-msisdn-dropdown>
            </div>
            <div class="col-12 m-t-xl" *ngIf="!isSingleLine">
              <hr class="divider" />
            </div>
          </div>
          <ng-container *ngIf="lineDetails && lineBillingDetails">
            <tmo-line-details
              id="line-details"
              #phoneDetails
              [lineDetails]="lineDetails"
              [isLineLandingPage]="true"
              [contentData]="contentData"
              [lineBillingDetails]="customerAccountLIneBillingDetails"
              [pendingOrdersCount]="pendingOrdersCountMessage"
              [setChangePlanPage]="line - landing"
              [customerBillingDetails]="customerAccountBillingDetails"
            >
            </tmo-line-details>
          </ng-container>
        </div>
        <div class="col-12 d-md-none m-t-xl">
          <hr class="divider" />
        </div>

        <!-- Ends left panel Section-->

        <!-- Starts right panel Section-->

        <div class="col-12 col-md-8 m-b-xl" [ngClass]="{ 'm-t-xl': selectedLineUsageSummary }">
          <!-- Start Usage Summary Section-->

          <ng-container *ngIf="isChangedMsisdnloaded && selectedLineUsageSummary">
            <tmo-usage-detail
              id="usage-detail"
              [contentData]="contentData"
              [isPayGoType]="isPayGoType"
              [lineUsageSummary]="selectedLineUsageSummary"
              [fraudLockIndicator]="fraudLockIndicator"
              [fraudLockedNotification]="fraudLockedNotification"
            >
            </tmo-usage-detail>
            <div class="row">
              <div class="col-12 button-spacing-legal" *ngIf="selectedLineUsageSummary?.msisdn">
                <button
                  type="button"
                  class="btn btn-primary"
                  id="view-usage"
                  [routerLink]="['/usage-details']"
                >
                  {{ contentData?.yourUsage }}
                </button>
              </div>
            </div>

            <div class="m-t-xl" *ngIf="selectedLineUsageSummary?.msisdn">
              <hr class="divider" />
            </div>
          </ng-container>

          <!-- End Usage Summary Section-->

          <!-- Start plan and service Section-->

          <ng-container *ngIf="contentData && authorableData">
            <tmo-plan-and-services
              id="plan-and-service"
              [contentData]="contentData"
              [authorableData]="authorableData"
              [showOnLineDetails]="true"
              [lineStatus]="lineStatus"
              [pendingOrdersModal]="pendingOrdersModal"
              [isPendingOrder]="isPendingOrder"
              (lineSelected)="onSelectionChange($event)"
              [isTouristPlan]="isTouristPlan"
              [broadbandFactsUrlChange]="broadbandFactsUrl"
            >
            </tmo-plan-and-services>
          </ng-container>

          <!-- Ends plan and service Section-->

          <div>
            <!-- Starts monthly charges section-->
            <p-accordion [multiple]="true" id="p-accordion-default-13">
              <p-accordionTab
                class="fractional"
                id="monthly-charges-tab"
                [selected]="false"
                *ngIf="lineBillingDetails?.msisdn"
              >
                <p-header>
                  <h6 class="title">{{ contentData?.monthlyCharges }}</h6>
                </p-header>
                <tmo-monthly-charges
                  id="monthly-charges"
                  [customerAccountBillingDetails]="customerAccountBillingDetails"
                  [contentData]="contentData"
                  [showOnLineDetails]="false"
                ></tmo-monthly-charges>
              </p-accordionTab>
              <!-- Ends monthly charges section-->

              <!-- Starts one time charges section-->
              <p-accordionTab
                class="fractional"
                [selected]="false"
                id="one-time-charges-tab"
                *ngIf="
                  passDetails?.active &&
                  selectedLineUsageSummary?.overages &&
                  showHideOneTimeChargeBlade()
                "
              >
                <p-header>
                  <div class="row n-p">
                    <div class="col-12">
                      <h6 class="title">{{ contentData?.oneTimeCharges }}</h6>
                    </div>
                  </div>
                </p-header>
                <tmo-one-time-charges
                  id="one-time-charges"
                  [passDetails]="passDetails"
                  [lineUsageSummary]="selectedLineUsageSummary"
                  [contentData]="contentData"
                  [showOnLineDetails]="false"
                ></tmo-one-time-charges>
              </p-accordionTab>
              <!-- Ends one time charges section-->

              <!-- Starts pending orders section-->
              <ng-container *ngIf="linePendingOrdersModel">
                <tmo-line-pending-orders
                  id="pending-orders"
                  [contentData]="contentData"
                  [linePendingOrdersModel]="linePendingOrdersModel"
                >
                </tmo-line-pending-orders>
              </ng-container>
              <!-- Ends pending orders section-->
            </p-accordion>
          </div>

          <!-- starts device and rep actions section-->

          <div class="m-t-lg" *ngIf="lineDetails">
            <tmo-line-device
              id="line-device"
              [contentData]="contentData"
              [lineDetails]="lineDetails"
              [selectedMsisdn]="lineDetails?.msisdn"
              *ngIf="contentData"
              [isTouristPlan]="isTouristPlan"
            ></tmo-line-device>
            <!-- <tmo-line-rep-actions id="rep-actions" [contentData]="contentData" *ngIf="contentData && !repToggle && !isWebChannel" [lineDetailsData]="lineDetails"
              [displayModifyCancellation]="displayModifyCancellationBlade"
              [isPostpaid]="isPostpaid" [isTouristPlan]="isTouristPlan"></tmo-line-rep-actions> -->
          </div>

          <!-- Ends device and rep actions section-->
        </div>

        <!-- Ends right panel Section-->
      </div>

      <!-- starts tertiary buttons section-->
      <div *ngIf="lineDetails">
        <!-- <tmo-line-details-tertiary-button id="line-details-buttons" [isWebChannel]="isWebChannel" [lineDetails]="lineDetails" [deviceDetailsLineInformation]="deviceDetailsLineInformation"
        [lineLandingConstants]="lineLandingConstants" [contentData]="contentData" [fraudLockIndicator]= "fraudLockIndicator"></tmo-line-details-tertiary-button> -->
        <tmo-line-details-tertiary-button
          id="line-details-buttons"
          [lineDetails]="lineDetails"
          [deviceDetailsLineInformation]="deviceDetailsLineInformation"
          [lineLandingConstants]="lineLandingConstants"
          [contentData]="contentData"
          [fraudLockIndicator]="fraudLockIndicator"
        ></tmo-line-details-tertiary-button>
      </div>
      <!-- Ends tertiary buttons section-->
    </ng-container>
  </section>
  <ng-container *ngIf="modal">
    <tmo-static-modal
      id="contact-us"
      #staticModal
      [modal]="modal"
      (onClose)="openModal(false)"
      (onSelect)="routeToContactUs('https://www.t-mobile.com/contact-us.html', true)"
    ></tmo-static-modal>
  </ng-container>
</div>
